var _path, _g, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistoryWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_122_555",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 43
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.442719 0H43.3333V42.6667H0.442719V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_122_555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2136 6.22925C28.0313 -1.94263 14.7709 -1.94263 6.59377 6.22925C5.60419 5.23966 3.91148 5.75529 3.63544 7.12508L2.47919 12.9011C2.2344 14.1251 3.31252 15.2084 4.54169 14.9636L10.3229 13.8074C11.6979 13.5313 12.2084 11.8438 11.2188 10.8542C16.8334 5.24487 25.9688 5.24487 31.5834 10.8542C37.2188 16.4845 37.2188 25.5626 31.5834 31.198C25.9688 36.8022 16.8334 36.8022 11.2188 31.198C8.41148 28.3907 7.01044 24.7084 7.01044 21.0261H7.00002C7.00002 19.2084 5.52086 17.7397 3.69794 17.7553C1.89065 17.7709 0.45315 19.2813 0.458358 21.0886C0.473983 26.422 2.51565 31.7501 6.59377 35.8178C14.7709 43.9897 28.0313 43.9897 36.2136 35.8178C44.3698 27.6667 44.3698 14.3803 36.2136 6.22925Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0052 22.0053L23.8542 19.6095V12.3699C23.8542 11.0157 22.7552 9.91675 21.4011 9.91675C20.0469 9.91675 18.9479 11.0157 18.9479 12.3699V21.0261C18.9479 21.9324 19.4427 22.724 20.1719 23.1459L25.5521 26.2501C26.7292 26.9272 28.2292 26.5261 28.9063 25.3542C29.5834 24.1824 29.1823 22.6824 28.0052 22.0053Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryWhite);
export default __webpack_public_path__ + "static/media/history-white.9cabf780c5e9d829e39723148931d739.svg";
export { ForwardRef as ReactComponent };